/**
 * V2 API - Replenishment, Alerts, Exceptions, Integration Health
 */
import api from './api';

// Replenishment API
export const replenishmentAPI = {
  generate: (data) => api.post('/replenishment/generate', data),
  list: (params = {}) => api.get('/replenishment/lists', { params }),
  get: (id) => api.get(`/replenishment/lists/${id}`),
  export: (id) => api.get(`/replenishment/lists/${id}/export`, { responseType: 'blob' }),
  delete: (id) => api.delete(`/replenishment/lists/${id}`),
  apply: (id, data) => api.post(`/replenishment/lists/${id}/apply`, data),
};

// Stage 8: Predictive Restock API
export const predictiveRestockAPI = {
  // Stock targets
  listTargets: (params = {}) => api.get('/inventory/stock-targets', { params }),
  upsertTargets: (targets) => api.put('/inventory/stock-targets', { targets }),
  deleteTarget: (id) => api.delete(`/inventory/stock-targets/${id}`),
  // Prediction engine
  getPlan: (params = {}) => api.get('/inventory/replenishment-plan', { params }),
  savePlan: (data) => api.post('/inventory/replenishment-plan/save', data),
};

// Alerts API
export const alertsAPI = {
  list: (params = {}) => api.get('/alerts', { params }),
  stats: () => api.get('/alerts/stats'),
  scan: () => api.post('/alerts/scan'),
  snooze: (id, days = 7) => api.post(`/alerts/${id}/snooze`, { days }),
  dismiss: (id) => api.post(`/alerts/${id}/dismiss`),
  resolve: (id) => api.post(`/alerts/${id}/resolve`),
};

// Exceptions API
export const exceptionsAPI = {
  list: (params = {}) => api.get('/exceptions', { params }),
  stats: () => api.get('/exceptions/stats'),
  get: (id) => api.get(`/exceptions/${id}`),
  create: (data) => api.post('/exceptions', data),
  acknowledge: (id) => api.post(`/exceptions/${id}/acknowledge`),
  resolve: (id, note = null) => api.post(`/exceptions/${id}/resolve`, { resolution_note: note }),
  ignore: (id, note = null) => api.post(`/exceptions/${id}/ignore`, { resolution_note: note }),
};

// Integration Health API
export const integrationHealthAPI = {
  get: () => api.get('/integrations/health'),
  getFeatures: () => api.get('/integrations/health/features'),
  updateFeatures: (data) => api.patch('/integrations/health/features', data),
};

export const jobTemplatesAPI = {
  list: () => api.get('/job-templates'),
  get: (id) => api.get(`/job-templates/${id}`),
  create: (data) => api.post('/job-templates', data),
  update: (id, data) => api.put(`/job-templates/${id}`, data),
  remove: (id) => api.delete(`/job-templates/${id}`),
  generateKit: (id, data) => api.post(`/job-templates/${id}/generate-kit`, data),
};

export default { replenishmentAPI, predictiveRestockAPI, alertsAPI, exceptionsAPI, integrationHealthAPI, jobTemplatesAPI };
